import { render, staticRenderFns } from "./MyTablesMfe.vue?vue&type=template&id=038090d0"
import script from "./MyTablesMfe.vue?vue&type=script&lang=js"
export * from "./MyTablesMfe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports